import { gql } from 'react-apollo';

export const resendEvangelistInvite = gql`
  mutation resendEvangelistInvite($input: ResendEvangelistInviteInput!) {
    resendEvangelistInvite(input: $input)
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/mutations/resendEvangelistInvite.js